export default __webpack_public_path__ + "img/chefsmaak-logo.c826e42604a57d9e43a31514ded00d90.png";